import React from 'react';
import { isEmpty } from 'lodash';
import Select from 'react-select';

// The two delivery states a planner can set by hand. "Available" is the ready
// state — there is no third option and no way back to unset.
export const DELIVERY_STATUS = [
    { label: 'In progress', value: 'IN_PROGRESS' },
    { label: 'Available', value: 'AVAILABLE' },
];

const selectStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: 20,
        width: 120,
        boxShadow: 'none',
        borderColor: '#369EE8',
        '&:hover': {
            borderColor: '#369EE8',
        },
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: 5,
        boxShadow: 'none',
        borderColor: '#727B848F',
        borderRadius: 5,
        borderStyle: 'solid',
        borderWidth: '1px 1px 1px 1px',
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 1500,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused || state.isSelected ? '#369EE8' : 'transparent',
        '&:hover': {
            backgroundColor: state.isFocused || state.isSelected ? '#369EE8' : '#ebf5ff',
        },
        color: state.isFocused || state.isSelected ? '#ffffff' : '#454545',
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: 14,
        color: '#369EE8',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#369EE8',
    }),
};

/**
 * The ready / in-progress control. Shared by the legacy booking row and the occasion
 * header so the two can never drift apart — a booking and an occasion are the same
 * document shape, and both address the same `PUT /bookings/:id/delivery-status`.
 *
 * `usePortal` renders the menu into document.body: the occasion header sits inside
 * stacking contexts that would otherwise clip it.
 */
const ACDeliveryStatusSelect = ({ value, onChangeFunc, usePortal = false }) => {
    const selectedStatus = DELIVERY_STATUS.find((s) => s.value === value) || null;

    const onChange = (option) => {
        if (!option || isEmpty(option)) return;
        onChangeFunc(option.value);
    };

    return (
        // Stop the click bubbling: in the booking row this control sits inside the
        // accordion summary, which would otherwise expand on every interaction.
        <div onClick={(e) => e.stopPropagation()}>
            <Select
                className="delivery-status-select"
                TextFieldProps={{
                    label: 'Delivery Status',
                    InputLabelProps: {
                        shrink: true,
                    },
                    placeholder: 'Select delivery status',
                }}
                options={DELIVERY_STATUS}
                value={selectedStatus}
                onChange={onChange}
                isSearchable={false}
                components={{
                    IndicatorSeparator: null,
                }}
                styles={selectStyles}
                {...(usePortal && { menuPortalTarget: document.body })}
            />
        </div>
    );
};

export default ACDeliveryStatusSelect;
